<!--头部-->
<template>
  <el-header class="header">
    <div style="display: flex; justify-content: space-between">
      <div>
        <slot>&emsp;</slot>
      </div>
      <div>
        <el-dropdown
          style="height: 30px; cursor: pointer;"
          placement="top"
          @command="handleCommand"
        >
          <span>
            <icon-svg icon-class="zhanghao" id="options"></icon-svg>
            <span>{{username}}</span>
            <i class="el-icon-arrow-down el-icon--right" id="arrow"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="openDialog">修改密码</el-dropdown-item>
            <el-dropdown-item command="cipher">获取邀请码</el-dropdown-item>
            <el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <el-dialog title="修改密码" :visible.sync="dialogVisible" width="400px">
      <el-form :model="changePassword" :rules="rules" ref="changePassword" label-width="100px">
        <el-form-item label="旧密码">
          <el-input type="password" v-model="changePassword.oldPass"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="pass">
          <el-input type="password" v-model="changePassword.pass"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input type="password" v-model="changePassword.checkPass"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="changeSubmit('changePassword')">确 定</el-button>
      </div>
    </el-dialog>
  </el-header>
</template>

<script>
export default {
  name: 'BaseHeader',
  data () {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.changePassword.checkPass !== '') {
          this.$refs.changePassword.validateField('checkPass')
        }
        callback()
      }
    }
    const validatePass2 = (rule, value, callback) => {
      if (value !== this.changePassword.pass) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      ChangePassURL: this.getDomain() + 'bmuser/change_pwd', // 修改密码
      GenerateCipherURL: this.getDomain() + 'bmuser/generate_cipher', // 获取注册邀请码
      username: sessionStorage.username,
      dialogVisible: false,
      theCipher: undefined,
      changePassword: {
        oldPass: '',
        pass: '',
        checkPass: ''
      },
      rules: {
        pass: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleCommand (command) {
      this[command]()
    },
    openDialog () {
      this.changePassword = {
        oldPassword: '',
        password: '',
        checkPassword: ''
      }
      this.dialogVisible = true
    },
    changeSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.axios.post(this.ChangePassURL, {
            token: sessionStorage.token,
            old_password: this.changePassword.oldPass,
            new_password: this.changePassword.pass
          }).then((data) => {
            if (data.data.err_code === 0) {
              sessionStorage.token = data.data.content.user.token
              this.$alert('密码修改成功', '成功', {
                confirmButtonText: '确定'
              }).then(() => {
                this.dialogVisible = false
              })
            } else if (data.data.err_code === 50004) {
              this.$alert('密码错误', '修改失败', {
                confirmButtonText: '确定'
              })
            } else {
              this.$alert('请检查网络', '登录失败', {
                confirmButtonText: '确定'
              })
            }
          })
        } else {
          return false
        }
      })
    },
    // 邀请码
    cipher () {
      this.axios.post(this.GenerateCipherURL, {
        token: sessionStorage.token
      }).then((data) => {
        if (data.data.err_code === 0) {
          this.theCipher = data.data.content.cipher
          this.$alert('邀请码:' + this.theCipher + '(十分钟内有效)', '邀请码', {
            confirmButtonText: '确定'
          })
        }
      })
    },
    // 退出登录
    logout () {
      delete sessionStorage.token
      delete sessionStorage.username
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
  #options {
    height: 1.3em;
    width: 1.3em;
    vertical-align: -0.15em;
  }
  #arrow {
    margin: 0 0 0 -2px;
  }
</style>
